import config from 'config';
import { formatString } from 'core/utilities';

import type { UtilLinks } from 'core';

const {
  app: { fallbackUrl },
} = config;

export const getFallbackToLink = (item: UtilLinks, isMultiBrand: boolean, currentCycle: number) => {
  const to = isMultiBrand && item?.toMultiBrand ? item?.toMultiBrand : item?.to;

  return item?.isMultiBrand
    ? `${fallbackUrl}${to}`
    : formatString(to, { CYCLE_NUMBER: currentCycle });
};
